import { postApi } from "./api_instance";

export const sessionCall = async ({ email, password, token}) => {
  try {
    const { data } = await postApi({
      apiUrl: "/admin/api/user/session/verify",
      dispatch: () => {},
      data: { email, password, token },
    });
    return data;
  } catch (error) {
    throw error;
  }
};
